// @ts-check
import { utcToLocal } from '@/Helpers/time';
import moment from 'moment';

export class PatientFileUploadModel {
  constructor({ Id = null, FileName, MimeType, Data, CreatedDate, PatientId }) {
    this.Id = Id;
    this.FileName = FileName;
    this.MimeType = MimeType;
    this.Data = Data;
    this.CreatedDate = CreatedDate ? utcToLocal(CreatedDate) : moment();
    this.PatientId = PatientId;
  }

  static get validations() {
    return {
      FileName: {}
    };
  }

  __copy() {
    return JSON.parse(JSON.stringify(this));
  }
}

export default PatientFileUploadModel;
